import React, { useState } from 'react'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import { Grid } from '@mui/material'
import SingleImage from '../../ePCR/Attachments/SingleImage'

const Attachments = ({ attachments }) => {
  return (
    <DetailsBox title="Attachments">
      <Grid container spacing={2}>
        {attachments.map((x, index) => (
          <SingleImage key={index} s3key={x.s3key} />
        ))}
      </Grid>
    </DetailsBox>
  )
}

export default Attachments
